
import { Vue, Prop, Options, Watch, Model } from "vue-property-decorator";
@Options({
  name: "Tirscript3InputComponent",
  emits: ["focus", "customInput", "update:modelValue", "click", "onEnter"],
})
export default class Tirscript3InputComponent extends Vue {
  @Prop({ default: false, type: Boolean }) readonly!: boolean;
  @Prop({ default: false, type: Boolean }) required!: boolean;
  @Prop({ default: true, type: Boolean }) showError!: boolean;
  @Prop({ default: 0 }) minLength!: number;
  @Prop({ default: "" }) placeholder!: string;
  @Prop({ default: "" }) icon!: string;
  @Prop({ default: "text" }) type!: string;
  @Prop({ default: "" }) label!: string;
  @Prop({ default: "" }) modelValue!: string;
  @Prop({ default: "" }) equal!: string;
  @Prop({ default: false, type: Boolean }) transformer!: boolean;
  @Prop({ default: false, type: Boolean }) right!: boolean;
  @Prop({ default: false, type: Boolean }) autofocus: boolean;
  @Prop({ default: false }) noBorder: boolean;
  @Prop({ default: "", type: String }) height!: string | undefined;
  @Prop({ default: false, type: Boolean }) lightBg: boolean;
  @Prop({ default: false, type: Boolean }) noMargin: boolean;
  @Prop({ default: false, type: Boolean }) requiredLabel: boolean;
  @Prop({ default: false, type: Boolean }) hasError: boolean;
  @Prop({ default: false, type: Boolean }) iconLeft: boolean;
  @Prop({ default: null }) regul: RegExp;

  //events
  //focus, input, click, onEnter
  borderRadius = 0;
  focused: boolean = false;
  innerHasError: boolean = false;
  errorMessage: string = "";
  innerValue: string = "";
  id = `ui_input_${Math.floor(Math.random() * 1000) + 1}`;
  mounted() {
    this.innerValue = this.modelValue;

    if (this.autofocus) {
      (this.$refs.inputEl as HTMLElement).focus();
    }
  }

  @Watch("hasError") onChangeHasError(value: boolean) {
    this.innerHasError = value;
  }
  @Watch("focused")
  onChangeFocus() {
    this.$emit("focus", this.focused);
  }

  @Watch("autofocus")
  getAutofocus() {
    if (this.autofocus) {
      (this.$refs.inputEl as HTMLElement).focus();
    }
    this.focused = this.autofocus;
    console.log(this.focused);
  }

  @Watch("innerValue")
  onInnerValueChanged(newValue: string) {
    this.isValid();
    if (this.innerValue !== this.modelValue) {
      this.$emit("customInput", this.innerValue);
      this.$emit("update:modelValue", this.innerValue);
    }
  }
  @Watch("modelValue")
  onValueChanged(newValue: string) {
    console.log(newValue, "newValue");

    if (this.innerValue !== this.modelValue) {
      this.innerValue = this.modelValue;
    }
  }
  created() {
    this.innerHasError = this.hasError;
    this.focused = this.autofocus;
    this.innerValue = this.modelValue;
  }
  click() {
    this.$emit("click", this.innerValue);
  }
  onEnter() {
    this.$emit("onEnter");
  }
  isValid(): boolean {
    this.errorMessage = "";
    if (this.regul) {
      this.validateValue();
    }
    if (this.required && !this.innerValue) {
      this.errorMessage = "*Поле обязательно";
      this.innerHasError = true;
      return false;
    }
    if (this.minLength && this.innerValue.length < this.minLength) {
      this.errorMessage = `*Минимум ${this.minLength} символов`;
      this.innerHasError = true;
      return false;
    }
    if (this.equal && this.innerValue !== this.equal) {
      this.errorMessage = `*Значения должны совпадать`;
      this.innerHasError = true;
      return false;
    }
    if (this.type === "email") {
      return this.validateEmail();
    }
    this.innerHasError = false;
    return true;
  }
  validateEmail(): boolean {
    var re =
      /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    var isValid = re.test(this.innerValue.toLowerCase());
    this.innerHasError = !isValid;
    if (!isValid) this.errorMessage = "*Не верный формат email";
    return isValid;
  }
  //валидация по регулярке
  validateValue() {
    this.innerValue = this.innerValue.replace(this.regul, "");
  }
}
